import * as Types from '../../types/graphql.gen';

import { gql } from '@apollo/client';
export type ChargeUnitFragment = { __typename?: 'Charge', id: string, amount: number | null, examinationFee: number | null, fastPassFee: number, createdAt: string, paidBy: Types.PaidBy | null, settledAt: string | null, settlementFee: number, insurancePaymentMethod: { __typename?: 'InsurancePaymentMethod', id: string, nationalInsurance: boolean, socialInsurance: boolean, selfPaid: boolean, other: boolean } | null };

export const ChargeUnitFragmentDoc = gql`
    fragment ChargeUnit on Charge {
  id
  amount
  examinationFee
  fastPassFee
  createdAt
  paidBy
  settledAt
  settlementFee
  insurancePaymentMethod {
    id
    nationalInsurance
    socialInsurance
    selfPaid
    other
  }
}
    `;